// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1CKIn","inputWrap":"Table_inputWrap__7dRV6","col":"Table_col__1bQIh","bmiTooltip":"Table_bmiTooltip__2wsCG"};